import {
    mapActions,
    mapGetters,
    mapMutations
} from 'vuex';
import CrossSellingsI18n from './CrossSellings.i18n.js';

export default {

    components: {},

    props: {
        codeArticle: {
            type: String,
            required: true
        }
    },

    computed: {
        ...mapGetters(['crossSellings', 'crossSellingsLoading','priceHiddenMode']),
    },

    data() {
        return {
            currentProducts: [],
            currentPage: 0,
            nbProductsDisplayed: 3,
            nbProduct: 3,
            leftArrowBlocked: true,
            rightArrowBlocked: true,
            reverse: 'same',
            transition: true,
            pastransition: false,
            screenWidth: 1200,
        };
    },

    watch: {},

    filters: {
      formatNumber: (pValue) => {
          return parseFloat(pValue).toLocaleString('fr-FR', {style: "currency", currency: "EUR"})
      },
    },


    methods: {
        ...mapActions(['getCrossSellings']),
        ...mapMutations(['setArticle']),

        /**
         * Fonction pour vérifier si une image existe.
         * @param {*} image_url
         * @returns
         */
        imageExists(image_url) {
            let img = new Image();
            img.src = "../" + image_url;
            if (img.height != 0) {
                return true;
            } else {
                return false;
            }
        },

        // Function to go to the next products
        goToNextProducts() {
            this.reverse = 'same';
            this.$nextTick(() => {
                let inter = this.pastransition;
                this.pastransition = this.transition;
                this.transition = inter;
                this.currentPage = this.currentPage + 1;
                this.changeProductList(this.currentPage);
            });
        },
        // Function to go to the previous products
        goToPreviousProducts() {
            this.reverse = 'reverse';
            this.$nextTick(() => {
                let inter = this.pastransition;
                this.pastransition = this.transition;
                this.transition = inter;
                this.currentPage = this.currentPage - 1;
                this.changeProductList(this.currentPage);
            });
        },
        // Function to change the product list
        changeProductList(pCurrentPage) {
            let i = 0;
            this.currentProducts = [];
            this.nbProductsDisplayed = 3;
            this.nbProduct = 3
            // Get the screen size
            if (this.screenWidth < 1120) {
                this.nbProductsDisplayed = 2;
                this.nbProduct = 2;
            }

            if (this.nbProductsDisplayed * (pCurrentPage + 1) > this.crossSellings.length) {
                this.nbProductsDisplayed = this.crossSellings.length - (pCurrentPage * this.nbProductsDisplayed)
            }

            while (i < this.nbProductsDisplayed) {
                this.currentProducts.push(this.crossSellings[i + (pCurrentPage * this.nbProduct)]);
                i = i + 1;
            }
            this.checkArrows(pCurrentPage)
        },
        // Function to block or not arrows
        checkArrows(pCurrentPage) {
            if (this.crossSellings[((pCurrentPage + 1) * this.nbProduct)]) {
                this.rightArrowBlocked = false;
            } else {
                this.rightArrowBlocked = true;
            }
            if (this.crossSellings[((pCurrentPage - 1) * this.nbProduct)]) {
                this.leftArrowBlocked = false;
            } else {
                this.leftArrowBlocked = true;
            }
        },

        /**
         * Fonction pour formatter le code article et enlever l'éventuel "/" en le remplaçant par "&".
         * @param {*} pCode
         * @returns
         */
        formatCodeArticle(pCode) {
            if (pCode.includes('/')) {
                pCode = pCode.replace('/', '$')
            }
            return pCode
        },

        /**
         * Fonction pour modifier le code article utilisé pour l'image. Remplacement de "/" par "-".
         * @param {*} pCode
         * @returns
         */
        formatCodeArticleForImage(pCode) {
            if (pCode.includes('/')) {
                pCode = pCode.replace('/', '-')
            }
            return pCode
        },

        /**
         * Fonction pour charger les articles dans le cross sellings.
         * @param {*}
         */
        loadCrossSellings(pCode) {
            const info = {
                codeArticle: this.formatCodeArticle(pCode),
            }
            this.getCrossSellings(info).then(res => {
                this.changeProductList(0);
            }).catch(err => {
                console.log(err)
            })
        },

        /**
         * Fonction pour aller vers l'article
         * @param {*} pArticle
         */
        goToArticle(pArticle) {
            //this.setArticle(pArticle);
            this.currentPage = 0
            this.loadCrossSellings(this.formatCodeArticle(pArticle.Code))

            this.$emit('getArticle', this.formatCodeArticle(pArticle.Code), true)
        },
        /**
         * Fonction pour obtenir le chemin de l'article.
         * @param {*} CodeFam
         * @returns
         */
        getArticlePath(CodeFam) {
            let subPath = ''
            if (CodeFam === 'PLA.') {
                subPath = 'plaques'
            } else if (CodeFam === 'FLE.') {
                subPath = 'fleurs'
            } else if (CodeFam === 'ACCESSOIRE.') {
                subPath = 'accessoires'
            } else if (CodeFam === 'BRONZE.') {
                subPath = 'bronze'
            } else if (CodeFam === 'INTER.') {
                subPath = 'inter'
            }
            return subPath
        },
    },

    mounted() {
        // Chargement des articles liés à partir du code article fourni
        window.addEventListener("resize", (e) => this.screenWidth = window.innerWidth);
        this.screenWidth = window.innerWidth;
        this.loadCrossSellings(this.codeArticle);
    },

    i18n: CrossSellingsI18n,

};
